import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";

export default (props) => {
  const columns = [
    {
      field: "ic",
      label: "IČO",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "name",
      label: "Název",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "username",
      label: "Přihlašovací jméno",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "email",
      label: "Email",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "contactPerson",
      label: "Kontaktní osoba",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "phone",
      label: "Tel. číslo",
      type: ColumnType.NUMBER,
      width: "12%",
    },
    {
      field: "accountValidityFrom",
      label: "Platnost od",
      type: ColumnType.DATE,
      width: "12%",
    },
    {
      field: "accountValidityTo",
      label: "Platnost do",
      type: ColumnType.DATE,
      width: "12%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const FinancialinstitutionsNoOfficialsGrid = (props) => {
  const columns = [
    {
      field: "ic",
      label: "IČO",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "name",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "username",
      label: "Přihlašovací jméno",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "email",
      label: "Email",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "contactPerson",
      label: "Kontaktní osoba",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "phone",
      label: "Tel. číslo",
      type: ColumnType.TEXT,
      width: "12%",
    },
    {
      field: "accountValidityFrom",
      label: "Platnost od",
      type: ColumnType.DATE,
      width: "12%",
    },
    {
      field: "accountValidityTo",
      label: "Platnost do",
      type: ColumnType.DATE,
      width: "12%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};
